import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../components/layout";
import Header from "../../../components/header";
import SubHeader from "../../../components/SubHeader";
import SiteButtons from "../../../components/SiteButtons";
import Container from "../../../components/Container";
import { URLS } from "../../../_config";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import AddCustomerGroupCustom from "./AddCustomerGroupCustom";
import AddCustomerGroupManual from "./AddCustomerGroupManual";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import { useCustomersApi } from "../../../store/api/hooks/customersApiHook";
import toast from "react-hot-toast";
import Permission, { hasPermission } from "../../../_config/Permission";
import { useMenuPermissionsSelector } from "../../../store/selectors/userSelector";
import { useTranslation } from "react-i18next";

interface PageProps {}

const AddCustomerGroup: React.FC<PageProps> = ({}) => {
  const { t } = useTranslation("customers");
  const allPermissions = useMenuPermissionsSelector();
  const permissionData = useMemo(() => allPermissions?.[URLS.CUSTOMER_GROUPS] || null, [allPermissions]);

  const navigate = useNavigate();
  const { type, id } = useParams();
  const commonApi = useCommonApi();
  const customerApi = useCustomersApi();
  const [isRender, setIsRender] = React.useState<boolean>(false);
  const { showLoader, hideLoader } = useAppLoader();
  const [customerGroupX, setCustomerGroupX] = React.useState<any>(null);

  const ini_page_data = async () => {
    setIsRender(false);
    if (id) {
      showLoader();
      const customerGroupResp: any = await new Promise((resolve, reject) =>
        customerApi.searchCustomerGroups({ customerGroupId: id }, resolve, reject)
      ).catch((err) => null);
      if (
        customerGroupResp &&
        customerGroupResp.hasOwnProperty("success") &&
        customerGroupResp.success &&
        customerGroupResp?.data &&
        customerGroupResp.data &&
        customerGroupResp?.data?.items
      ) {
        setCustomerGroupX(customerGroupResp?.data?.items);
        console.log("Fetched", customerGroupResp?.data?.items);
        setIsRender(true);
      } else {
        toast.error(
          customerGroupResp?.errorMessage || t("addCustomerGroup.toasts.fetchFailed")
        );
      }
      hideLoader();
    } else {
      setIsRender(true);
    }
  };

  useEffect(() => {
    ini_page_data();
    commonApi.locationSearch(
      {},
      () => {},
      (error: any) => {
        console.log("Locations load error:", error);
      }
    );
    customerApi.listCustomerGroups(
      {},
      () => {},
      (error: any) => {
        console.log("Customer groups load error:", error);
      }
    );
  }, []);

  return (
    <Layout manualNavigationBlocked={hasPermission(permissionData, "W")} alertMessageForBeforeUnload={t("addCustomerGroup.unsavedChangesWarning")}>
      <Header />
      <Permission value={permissionData} check="W" page={true}>
      {isRender && (
        <div>
          {(() => {
            switch (type?.toUpperCase()) {
              case `CUSTOM`:
                return (
                  <AddCustomerGroupCustom
                    type={type.toLowerCase()}
                    customergroup={customerGroupX}
                  />
                );
              case `MTQ3`:
                return (
                  <AddCustomerGroupManual
                    type={type.toLowerCase()}
                    customergroup={customerGroupX}
                  />
                );
              default:
                return (
                  <p className={`p-2 text-gray-700 font-semibold`}>
                    {t("addCustomerGroup.typeNotFound")}
                  </p>
                );
            }
          })()}
        </div>
      )}
      </Permission>
    </Layout>
  );
};

export default AddCustomerGroup;